module.exports = __webpack_public_path__ + "img/3.25e4db06.png";